import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { LocationState, ILocationState } from 'shared/types/navigation';

type LocationStateUpdates = Partial<Record<keyof ILocationState, any>>; // eslint-disable-line @typescript-eslint/no-explicit-any

/**
 * Pass and update values between routes in location state
 */
const useLocationState = (): [ILocationState, (stateUpdates: LocationStateUpdates) => void] => {
  const {
    location: { state: locationState, pathname: locationPathname },
    replace: replaceHistoryEntry,
  } = useHistory<LocationState>();

  const setLocationState = useCallback(
    (stateUpdates: LocationStateUpdates) => {
      replaceHistoryEntry(locationPathname, { ...locationState, ...stateUpdates });
    },
    [locationState, locationPathname, replaceHistoryEntry],
  );

  return [locationState || {}, setLocationState];
};

export default useLocationState;
